import { render, staticRenderFns } from "./chemicalRegister.vue?vue&type=template&id=4654e8ed&scoped=true&"
import script from "./chemicalRegister.vue?vue&type=script&lang=js&"
export * from "./chemicalRegister.vue?vue&type=script&lang=js&"
import style0 from "./chemicalRegister.vue?vue&type=style&index=0&id=4654e8ed&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4654e8ed",
  null
  
)

export default component.exports